import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';

export default function AdminLevelRulesPage() {
  const { data: rules } = useQuery({ queryKey: ['levelRules'], queryFn: () => api.get('/commissions/rules').then(r => r.data) });
  const levelRules = rules?.filter((r: any) => r.type === 'LEVEL') || [];
  const totalPercentage = levelRules.reduce((sum: number, r: any) => sum + parseFloat(r.percentage), 0);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-white">Level Rules</h1><p className="text-sm text-slate-400">30-level income distribution structure (from pool)</p></div>
        <div className={`px-3 py-1 rounded-full text-sm font-semibold ${totalPercentage === 100 ? 'bg-emerald-500/15 text-emerald-400' : 'bg-red-500/15 text-red-400'}`}>
          Total: {totalPercentage.toFixed(1)}%
        </div>
      </div>
      <Card><CardContent className="p-0"><div className="overflow-x-auto"><table className="w-full">
        <thead><tr className="border-b border-white/[0.06] bg-white/[0.02]">
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Level</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Pool Share %</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Status</th>
        </tr></thead>
        <tbody className="divide-y divide-white/[0.04]">{levelRules.map((r: any) => (
          <tr key={r.id} className="hover:bg-white/[0.02]">
            <td className="px-4 py-3 text-sm font-medium text-white">Level {r.level || r.name?.replace('Level ', '')}</td>
            <td className="px-4 py-3 text-sm font-medium text-white">{r.percentage}%</td>
            <td className="px-4 py-3"><Badge status={r.isActive ? 'ACTIVE' : 'INACTIVE'} /></td>
          </tr>
        ))}</tbody>
      </table></div></CardContent></Card>
      {totalPercentage !== 100 && (
        <div className="p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg text-sm text-amber-400">
          Total distribution must equal exactly 100%. Currently at {totalPercentage.toFixed(1)}% — {totalPercentage < 100 ? `${(100 - totalPercentage).toFixed(1)}% unallocated` : `${(totalPercentage - 100).toFixed(1)}% over-allocated`}
        </div>
      )}
    </div>
  );
}
